import VueRouter              from 'vue-router'
import Root                   from '@/pages/Root.vue'
import Authenticated          from '@/templates/Authenticated.vue'
import Login                  from '@/pages/Login.vue'
import Logout                 from '@/pages/Logout.vue'
import PasswordResetNew       from '@/pages/PasswordResetNew.vue'
import PasswordReset          from '@/pages/PasswordReset.vue'
import Teams                  from '@/pages/Teams.vue'
import TeamSidebar            from '@/pages/TeamSidebar.vue'
import Blasts                 from '@/pages/Blasts.vue'
import BlastNew               from '@/pages/BlastNew.vue'
import Blast                  from '@/pages/Blast.vue'
import Calls                  from '@/pages/Calls.vue'
import Conversations          from '@/pages/Conversations.vue'
import NoHomeNumberSelected   from '@/pages/NoHomeNumberSelected.vue'
import MessageNew             from '@/pages/MessageNew.vue'
import HomeNumber             from '@/pages/HomeNumber.vue'
import HomeNumberEdit         from '@/pages/HomeNumberEdit.vue'
import GradeLevelNone         from '@/pages/GradeLevelNone.vue'
import GradeLevel             from '@/pages/GradeLevel.vue'
import GradeLevelDelete       from '@/pages/GradeLevelDelete.vue'
import GradeLevelEdit         from '@/pages/GradeLevelEdit.vue'
import Group                  from '@/pages/Group.vue'
import GroupDelete            from '@/pages/GroupDelete.vue'
import GroupEdit              from '@/pages/GroupEdit.vue'
import Search                 from '@/pages/Search.vue'
import Settings               from '@/pages/Settings.vue'
import Students               from '@/pages/Students.vue'
import GroupNew               from '@/pages/GroupNew.vue'
import GradeLevelNew          from '@/pages/GradeLevelNew.vue'
import StudentsAll            from '@/pages/StudentsAll.vue'
import Student                from '@/pages/Student.vue'
import StudentEdit            from '@/pages/StudentEdit.vue'
import StudentDelete          from '@/pages/StudentDelete.vue'
import StudentDataloads       from '@/pages/StudentDataloads.vue'
import StudentDataloadNew     from '@/pages/StudentDataloadNew.vue'
import StudentDataloadProcess from '@/pages/StudentDataloadProcess.vue'
import Team                   from '@/pages/Team.vue'
import NotFound               from '@/pages/NotFound.vue'

let routes = [
  {
    path: '/oldroot',
    components: {
      default: Root,
    },
    name: 'root',
    props: { default: true }
  },
  {
    path: '/login',
    component: Login,
    name: 'login'
  },
  {
    path: '/logout',
    component: Logout,
    name: 'logout'
  },
  {
    path: '/password_resets/new',
    component: PasswordResetNew,
    name: 'passwordResetNew'
  },
  {
    path: '/password_resets/:passwordResetToken',
    component: PasswordReset,
    name: 'passwordReset'
  },
  {
    path:'/',
    component: Authenticated,
    props: true,
    children: [
      {
        path: '/teams/',
        components:{
          default: Teams,
        },
        name: 'teams',
        props: true,
      },
      {
        path: 'teams/:teamId',
        component: TeamSidebar,
        props: true,
        children: [
          {
            path: 'blasts',
            component: Blasts,
            name: 'blasts',
            props: true,
            meta: { layout: 'sidebar-single' }
          },
          {
            path: 'blasts/new',
            component: BlastNew,
            name: 'blastNew',
            props: true,
            meta: { layout: 'sidebar-single' }
          },
          {
            path: 'blasts/:blastId',
            component: Blast,
            name: 'blast',
            props: true,
            meta: { layout: 'sidebar-single' }
          },
          {
            path: 'calls',
            component: Calls,
            name: 'calls',
            props: true,
          },
          {
            path: 'conversations',
            component: Conversations,
            props: true,
            children: [
              {
                path: '',
                name: 'conversations',
                props: true,
                component: NoHomeNumberSelected,
              },
              {
                path: 'messages/new',
                name: 'conversationsMessageNew',
                props: { default: true, modal: true },
                components: {
                  default: NoHomeNumberSelected,
                  modal: MessageNew,
                }
              },
              {
                path: 'home_numbers/:homeNumberId',
                name: 'homeNumber',
                props: true,
                component: HomeNumber,
                children: [
                  {
                    path: 'messages/new',
                    name: 'homeNumberMessageNew',
                    props: true,
                    component: MessageNew,
                  },
                  {
                    path: 'edit',
                    component: HomeNumberEdit,
                    name: 'homeNumberEdit',
                    props: true
                  }
                ]
              }
            ]
          },
          {
            path: 'grade_levels/none',
            component: GradeLevelNone,
            name: 'gradeLevelNone',
            props: true,
          },
          {
            path: 'grade_levels/:gradeLevelId',
            component: GradeLevel,
            name: 'gradeLevel',
            props: true,
            children: [
              {
                path: 'delete',
                component: GradeLevelDelete,
                name: 'gradeLevelDelete',
                props: true
              },
              {
                path: 'edit',
                component: GradeLevelEdit,
                name: 'gradeLevelEdit',
                props: true
              }
            ],
          },
          {
            path: 'groups/:groupId',
            component: Group,
            name: 'group',
            props: true,
            children: [
              {
                path: 'delete',
                component: GroupDelete,
                name: 'groupDelete',
                props: true
              },
              {
                path: 'edit',
                component: GroupEdit,
                name: 'groupEdit',
                props: true
              }
            ],
          },
          {
            path: 'search',
            component: Search,
            name: 'search',
            props: true,
          },
          {
            path: 'settings',
            component: Settings,
            name: 'settings',
            props: true,
          },
          {
            path: 'students',
            component: Students,
            name: 'students',
            props: true,
            children: [
              {
                path: 'groups/new',
                component: GroupNew,
                name: 'groupNew',
                props: true,
              },
              {
                path: 'grade_levels/new',
                component: GradeLevelNew,
                name: 'gradeLevelNew',
                props: true,
              },
            ]
          },
          {
            path: 'students/all',
            component: StudentsAll,
            name: 'studentsAll',
            props: true,
          },
          {
            path: 'students/:studentId',
            component: Student,
            name: 'student',
            props: true,
            children: [
              {
                path: 'edit',
                component: StudentEdit,
                name: 'studentEdit',
                props: true,
              },
              {
                path: 'delete',
                component: StudentDelete,
                name: 'studentDelete',
                props: true,
              },
            ]
          },
          {
            path: 'student_dataloads',
            name: 'studentDataloads',
            component: StudentDataloads,
            props: true
          },
          {
            path: 'student_dataloads/new',
            name: 'studentDataloadNew',
            component: StudentDataloadNew,
            props: true
          },
          {
            path: 'student_dataloads/:id/process',
            name: 'studentDataloadProcess',
            component: StudentDataloadProcess,
            props: true
          },
          {
            path: '',
            component: Team,
            name: 'team',
            props: true,
          },
        ]
      }
    ]
  },
  {
    path: '*',
    component: NotFound,
    name: 'notFound',
    props: { default: true }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/',
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
})

router.beforeEach((to, from, next) => {
  if (to.matched.length == 0) {
    next(false)
  } else {
    next()
  }
})

export default router
